module.exports = __webpack_public_path__ + "static/media/digital.0b9d4373.png";